/**
 * Nhóm ngành nghề chính tính thuế GTGT
 * NHANH3 13.05.2024
 */
export default {
  ServiceFreeTax: 0,
  ProvideItem: 1,
  ConstructionNotIncludeMaterials: 5,
  ConstructionIncludeMaterials: 3,
  OtherService: 2,
};